export function terminationAgreementSellerDC523() {
return [   //2024 Release 2025-06-03 08:01:56
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 63.673,
 left: 53,
 width: 180,
 height: 27,
 }, 
{
   page: 0,
   name: "THIS FORM HAS NOT BEEN APPROVED BY THE COLORADO REAL ESTATE COMMISSION IT WAS PREPARED BY", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 50.92,
   left: 324.72,
   width: 248.444,
   height: 11.596
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 130.04,
   left: 216.0,
   width: 159.36,
   height: 14.44
}
,
{
   page: 0,
   name: "SELLER LISTING CONTRACT TERMINATION AGREEMENT 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 153.32,
   left: 216.0,
   width: 318.24,
   height: 14.44
}
,
{
   page: 0,
   name: "SELLER LISTING CONTRACT TERMINATION AGREEMENT 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 176.6,
   left: 216.0,
   width: 318.24,
   height: 14.2
}
,
{
   page: 0,
   name: "SELLER LISTING CONTRACT TERMINATION AGREEMENT 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 199.64,
   left: 216.0,
   width: 318.24,
   height: 14.44
}
,
{
   page: 0,
   name: "Seller Listing Contract Date 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 222.92,
   left: 216.0,
   width: 318.24,
   height: 14.20
}
,
{
   page: 0,
   name: "Seller Listing Contract Date 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 245.96,
   left: 216.0,
   width: 318.24,
   height: 14.44
}
,
{
   page: 0,
   name: "signature BROKERAGE FIRM AND BROKER", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 620.04,
   left: 324.0,
   width: 213.6,
   height: 15.44
}
,
{
   page: 0,
   name: "signature CoBroker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 673.56,
   left: 324.0,
   width: 213.6,
   height: 15.44
}
,
{
   page: 0,
   name: "use by", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 741.4911,
   left: 85.4604,
   width: 217.1126,
   height: 12.6217
}
] }
